module.exports = __webpack_public_path__ + "img/guide_green.44974495.jpg";